import RichText from './RichText';
import EmptySpace from './EmptySpace';
import Intro from './Intro';
import Video from './Video';
import BookMeeting from './BookMeeting';
import Calculator from './Calculator';
import Image from './Image';
import PageTitle from './PageTitle';
import TimePlan from './TimePlan';
import TimePlanNew from './TimePlanNew';
import ImportantDates from './ImportantDates';
import Employees from './Employees';
import TitleAndDescription from './TitleAndDescription';
import RelatedArticles from './RelatedArticles';
import Author from './Author';
import Widgets from './Widgets';
import Courses from './Courses';
import Contact from './Contact';

export default {
    rich_text: RichText,
    empty_space: EmptySpace,
    courses: Courses,
    intro: Intro,
    video: Video,
    book_meeting: BookMeeting,
    grade_calculator: Calculator,
    image: Image,
    page_title: PageTitle,
    time_plan: TimePlan,
    time_plan_new: TimePlanNew,
    important_dates: ImportantDates,
    employees: Employees,
    title_and_description: TitleAndDescription,
    last_blog_posts: RelatedArticles,
    author: Author,
    widgets: Widgets,
    contact: Contact
}


// WEBPACK FOOTER //
// ./src/partials/modules/index.js